<template>
  <div
    class="tooth"
    v-click-outside="onCloseMenu">
    <tooth-popover-menu
      v-bind:value="isShowMenu"
      v-bind:flip="flip">
      <template slot="trigger">
        <div class="tooth__body">
          <button
            class="tooth__body__bone"
            type="button"
            v-bind:class="{ [round]: isMilky, selected: isSelected('bone') }"
            v-bind:style="{ 'background-color': partColor['bone'] || '#ffead2' }"
            v-on:click="onClick('bone', $event)" />
          <button
            class="tooth__body__gingiva"
            type="button"
            v-bind:class="{ [round]: isMilky, selected: isSelected('gingiva') }"
            v-bind:style="{ 'background-color': partColor['gingiva'] || '#f4ddc1' }"
            v-on:click="onClick('gingiva', $event)" />
          <button
            class="tooth__body__all-tooth"
            type="button"
            v-on:click="onAllToothClick($event)" />
          <svg
            v-if="!isDeleted"
            class="tooth-up-5 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 68 179">
            <g v-if="isDiagnosisImplant" id="implant">
              <rect width="25.564" height="13.231" x=".5" y="-.5" fill="#A8BEC5" stroke="#778F9F" rx="1.397" transform="matrix(1 0 0 -1 22.441 74.013)" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.14 57.422H25.306l4.836-55.777h11.904l4.092 55.777Z" />
              <rect width="29.845" height="4.309" x="20.8" y="56.947" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M22.643 52.764a1.68 1.68 0 0 0 1.94 1.372l23.52-4.032.168-.037a1.68 1.68 0 0 0-.736-3.275l-23.52 4.032a1.68 1.68 0 0 0-1.372 1.94Zm2.434-5.266.17-.02 22.176-3.697a1.68 1.68 0 1 0-.552-3.314l-22.176 3.696-.168.037a1.68 1.68 0 0 0 .55 3.297Zm.339-6.326.172-.02 21.84-3.696a1.68 1.68 0 0 0-.561-3.313l-21.84 3.696-.169.037a1.68 1.68 0 0 0 .558 3.296Zm-.759-7.729a1.68 1.68 0 0 0 1.93 1.386l20.496-3.36a1.68 1.68 0 0 0-.544-3.315l-20.496 3.36a1.68 1.68 0 0 0-1.386 1.93Zm2.143-4.924.17-.024 19.152-3.696a1.68 1.68 0 0 0-.636-3.3l-19.154 3.697-.166.041a1.68 1.68 0 0 0 .633 3.282Zm.67-5.989.17-.024 17.472-3.36.168-.04a1.68 1.68 0 0 0-.802-3.26l-17.472 3.36-.168.041a1.68 1.68 0 0 0 .632 3.284Zm.295-6.657.17-.02 16.128-2.689a1.68 1.68 0 1 0-.552-3.314l-16.128 2.688-.168.037a1.68 1.68 0 0 0 .55 3.298Zm.389-6.33.17-.025 15.121-3.024.167-.042a1.68 1.68 0 0 0-.827-3.253l-15.12 3.024-.167.042a1.68 1.68 0 0 0 .656 3.278Z" />
            </g>
            <g v-else>
              <path
                d="M24.968 50.9315C24.5399 52.8952 23.661 65.268 23.2751 71.209L47.3379 70.9955C46.6243 61.6394 44.9831 40.6647 44.1269 31.6145C43.0565 20.3018 37.1697 7.06805 34.6009 3.33272C32.0321 -0.402611 27.4297 -0.829506 28.5 6.4277C29.5704 13.6849 28.393 28.8397 27.9649 32.7885C27.5367 36.7372 25.5031 48.4768 24.968 50.9315Z"
                v-bind:class="{ selected: isSelected('root_1') }"
                v-bind:fill="partColor['root_1'] || '#FFF'"
                v-on:click="onClick('root_1', $event)"
                v-on:keydown="onClick('root_1', $event)" />
              <path
                d="M37.5488 56.0475L38.524 55.7985C38.9448 55.6911 39.3251 55.4633 39.6185 55.1431C40.1744 54.5363 40.3725 53.6857 40.16 52.8908C36.2735 38.3549 35.8986 19.8828 34.935 16.3913C34.9028 16.2747 34.8461 16.179 34.7693 16.0856C34.4726 15.7245 33.9205 15.6949 33.6235 16.0557C33.5219 16.1791 33.4488 16.2824 33.4503 16.3221C33.9445 29.4433 32.678 46.4162 30.836 53.8892L30.6936 54.5137C30.5839 54.9951 30.7323 55.499 31.0855 55.844C31.289 56.0428 31.5475 56.1758 31.8275 56.2258L32.6482 56.3724L34.0936 56.4298L35.5085 56.336L37.5488 56.0475Z"
                v-bind:class="{ selected: isSelected('central_canal') }"
                v-bind:fill="partColor['central_canal'] || '#FF82BE'"
                v-on:click="onClick('central_canal', $event)"
                v-on:keydown="onClick('central_canal', $event)" />
            </g>
            <path
              v-if="!isDiagnosisImplant || hasCrownOnImplant"
              d="M46.16 93.767c-4.11 4.269-8.99 5.407-10.917 5.443a17.442 17.442 0 0 1-1.435-.439C23.433 95.113 18.437 82.09 23.275 72.21c.48-.98 1.04-1.945 1.693-2.882 4.88-7 11.31-6.118 13.914-4.802 1.534.925 5.373 3.714 8.456 7.47 3.082 3.757 3.353 9.463 3.104 11.847-.108 1.6-.172 5.656-4.282 9.925Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
          <svg
            v-else-if="isBoneImplant"
            class="tooth-up-5 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 68 179">
            <g id="implant">
              <rect width="25.564" height="13.231" x=".5" y="-.5" fill="#A8BEC5" stroke="#778F9F" rx="1.397" transform="matrix(1 0 0 -1 22.441 74.013)" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.14 57.422H25.306l4.836-55.777h11.904l4.092 55.777Z" />
              <rect width="29.845" height="4.309" x="20.8" y="56.947" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M22.643 52.764a1.68 1.68 0 0 0 1.94 1.372l23.52-4.032.168-.037a1.68 1.68 0 0 0-.736-3.275l-23.52 4.032a1.68 1.68 0 0 0-1.372 1.94Zm2.434-5.266.17-.02 22.176-3.697a1.68 1.68 0 1 0-.552-3.314l-22.176 3.696-.168.037a1.68 1.68 0 0 0 .55 3.297Zm.339-6.326.172-.02 21.84-3.696a1.68 1.68 0 0 0-.561-3.313l-21.84 3.696-.169.037a1.68 1.68 0 0 0 .558 3.296Zm-.759-7.729a1.68 1.68 0 0 0 1.93 1.386l20.496-3.36a1.68 1.68 0 0 0-.544-3.315l-20.496 3.36a1.68 1.68 0 0 0-1.386 1.93Zm2.143-4.924.17-.024 19.152-3.696a1.68 1.68 0 0 0-.636-3.3l-19.154 3.697-.166.041a1.68 1.68 0 0 0 .633 3.282Zm.67-5.989.17-.024 17.472-3.36.168-.04a1.68 1.68 0 0 0-.802-3.26l-17.472 3.36-.168.041a1.68 1.68 0 0 0 .632 3.284Zm.295-6.657.17-.02 16.128-2.689a1.68 1.68 0 1 0-.552-3.314l-16.128 2.688-.168.037a1.68 1.68 0 0 0 .55 3.298Zm.389-6.33.17-.025 15.121-3.024.167-.042a1.68 1.68 0 0 0-.827-3.253l-15.12 3.024-.167.042a1.68 1.68 0 0 0 .656 3.278Z" />
            </g>
            <path
              v-if="hasCrownOnImplant"
              d="M46.16 93.767c-4.11 4.269-8.99 5.407-10.917 5.443a17.442 17.442 0 0 1-1.435-.439C23.433 95.113 18.437 82.09 23.275 72.21c.48-.98 1.04-1.945 1.693-2.882 4.88-7 11.31-6.118 13.914-4.802 1.534.925 5.373 3.714 8.456 7.47 3.082 3.757 3.353 9.463 3.104 11.847-.108 1.6-.172 5.656-4.282 9.925Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
        </div>
      </template>
      <form-teeth-formula-diagnoses
        v-bind:class="{ 'disable-component': disabled }"
        v-bind:is-deleted="needDeleted"
        v-bind:part-list="partList"
        v-bind:has-implant="hasImplant"
        v-on:cancel="onCloseMenu"
        v-on:change-diagnoses="onChangeDiagnoses"
        v-on:change-tooth-deleted="onChangeToothDeleted"
        v-on:submit="onSubmit" />
    </tooth-popover-menu>
    <top-tooth-surface
      v-bind:surface="surface"
      v-bind:part-selected="partSelected"
      v-bind:selected-parts="selectedParts"
      v-bind:flip="flip"
      v-on:select="onClick" />
    <div class="tooth__number">{{ tooth.number }}</div>
  </div>
</template>
<script>
import toothMixin from '@/mixins/toothMixin';
import ToothPopoverMenu from '../ToothPopoverMenu.vue';
import FormTeethFormulaDiagnoses from '../FormTeethFormulaDiagnoses.vue';
import TopToothSurface from '../TopToothSurface.vue';

export default {
  components: {
    ToothPopoverMenu,
    FormTeethFormulaDiagnoses,
    TopToothSurface,
  },
  computed: {
    round: ({ flip }) => (flip ? 'round-right' : 'round-left'),
  },
  mixins: [toothMixin],
  name: 'ToothUp5',
  props: {
    isMilky: { type: Boolean, default: false },
  },
};
</script>

<style>
.tooth__body__bone.round-left {
  border-radius: 20px 0 0 0;
}
.tooth__body__bone.round-right {
  border-radius: 0 20px 0 0;
}
.tooth__body__gingiva.round-left {
  border-radius: 0 0 0 10px;
}
.tooth__body__gingiva.round-right {
  border-radius: 0 0 10px 0;
}
</style>
